module.exports = __webpack_public_path__ + "static/media/levels_1_4.7f39ac9b.svg";